import { BreadcrumbProps as _BreadcrumbProps } from 'antd'
import { getBreadCrumbItems } from 'shared/common/AppBreadcrumb/helper/getBreadcrumbItem'
import { Icon } from 'shared/iconpack'
import clsx from 'shared/libs/clsx'

import { useEffect, useState } from 'react'

import { useLocation, useParams } from 'react-router-dom'

import { Breadcrumb } from 'shared/ui/Breadcrumb'

import { useAppSelector } from 'shared/config/redux/hooks/useRedux'
import { palette } from 'shared/config/styles/palette'

import './Breadcrumb.css'

type BreadcrumbProps = _BreadcrumbProps

const AppBreadcrumb = (props: BreadcrumbProps) => {
  const location = useLocation()
  const breadcrumbsState = useAppSelector((state) => state.breadcrumbs)
  const [searchParams, setSearchParams] = useState<Record<string, string>>({})
  const params = useParams()
  const extraBreadcrumbItems = getBreadCrumbItems(
    location.pathname,
    breadcrumbsState,
    searchParams,
    params,
  )

  useEffect(() => {
    if (searchParams[location.pathname] || location.search) {
      if (searchParams[location.pathname] !== location.search) {
        setSearchParams((prev) => ({
          ...prev,
          [location.pathname]: location.search,
        }))
      }
    }
  }, [location])

  return (
    <Breadcrumb
      items={extraBreadcrumbItems}
      className="customBreadcrumb"
      separator={
        <Icon
          name="breadcrumbSeparator"
          size={16}
          color={palette.light_gray_8}
        />
      }
      itemRender={(route, _params, _items, _paths) => {
        const isLast = extraBreadcrumbItems.at(-1)?.key === route.key
        return <span className={clsx({ ['last']: isLast })}>{route.title}</span>
      }}
      {...props}
    />
  )
}

export default AppBreadcrumb
